import { render, staticRenderFns } from "./PrisonerFeedback.vue?vue&type=template&id=7e7332d2&"
import script from "./PrisonerFeedback.vue?vue&type=script&lang=js&"
export * from "./PrisonerFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports